import React, {ChangeEvent} from "react";
import Divider from "../platformSection/general/Divider";
import {Container, Row} from "react-grid-system";
import {
    Accordion,
    AccordionItem,
    AccordionItemButton,
    AccordionItemHeading,
    AccordionItemPanel
} from 'react-accessible-accordion';
import {FAQ} from "../../../../model/FAQ";
import {Reference} from "../../../../res/Reference";
import {RawProvider} from "../../../../res/RawProvider";

interface FaqSectionStates {
    faq: [FAQ]
}

interface FaqSectionProps {
}

export class FaqSection extends React.Component<FaqSectionProps, FaqSectionStates> {

    state: FaqSectionStates

    faqs: [FAQ] = RawProvider.faq

    constructor(props: FaqSectionProps) {
        super(props)
        this.state = {
            faq: this.faqs
        }

    }

    filterFAQ = (value: string) => {
        if (value.length > 0) {
            return this.faqs.filter(faq => {
                return faq.question.toLowerCase().includes(value.toLowerCase()) &&
                    faq.answer.includes(value)
            }) as [FAQ];
        }
        return this.faqs
    }

    searchTextChanged = (event: ChangeEvent<HTMLInputElement>) => {
        this.setState({
                faq: this.filterFAQ(event.target.value)
            }
        )
    }

    render() {
        return <section
            id={Reference.faqSection}
            className="faqSection">
            <Container>
                <Divider className="centerDivider"/>
                <Row style={{justifyContent: "center"}}>
                    <div
                        className="title"
                        style={{color: "#2F3133"}}>
                        FAQ
                    </div>
                </Row>
                <Row>
                    <input
                        className="searchFAQInput"
                        type="text"
                        placeholder="Search FAQ..."
                        onChange={this.searchTextChanged}/>
                </Row>
                <Row>
                    <Accordion
                        allowZeroExpanded={true}>
                        {this.state.faq.map(faq => {
                            return (
                                <AccordionItem>
                                    <AccordionItemHeading>
                                        <AccordionItemButton>
                                            {faq.question}
                                        </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                        <p dangerouslySetInnerHTML={{__html: faq.answer}}/>
                                    </AccordionItemPanel>
                                </AccordionItem>
                            );
                        })}
                    </Accordion>
                </Row>
            </Container>
        </section>;
    }

}
